import React from 'react';
import clsx from 'clsx';

import {ArrowLeftIcon} from '../Icon';

import {toVND} from '../../utils';

import styles from './PriceDisplay.module.css';

interface PriceProps {
  price: number
  isDiscounted: boolean
  finalPrice: number
}


const PriceDisplay = ({price, finalPrice, isDiscounted}: PriceProps) => {

  return (
    <div className={styles.root}>
      <div className={styles.priceContainer}>
        {
          isDiscounted &&
          <>
            <span className={clsx(styles.price, styles.fakePrice)} data-manabie="PriceDisplay-fake-price">
              {toVND(price)}
            </span>
            <ArrowLeftIcon className={styles.priceArrow}/>
          </>
        }
        <span className={clsx(styles.price)}>
          {toVND(finalPrice)}
        </span>
      </div>
    </div>
  );
};

export default PriceDisplay;